module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/quickstart-optimistic-step-4.json
// module id = 2364
// module chunks = 214543632145702